import React, { useMemo, useState } from "react";
import {
  compose,
  withPropsOnChange,
  withStateHandlers,
  branch,
  withHandlers,
} from "recompose";
import { LocalForm, Control, actions, Fieldset, track, Errors } from "react-redux-form";
import {
  Col,
  Row,
  Button,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { createSelector } from "reselect";
import { NotificationManager } from "react-notifications";
import {
  Page,
  FormGroup,
  required,
  SaveButton,
  withReload,
} from "components/common";
import Select from "react-select";
import { isEmail } from "validator";
import { paymentTerms } from "constants/xero";
import { withXeroErrors, AccountSelect } from "components";
import { Trans } from "react-i18next";
import produce from "immer";
import { Link } from "react-router-dom";
import FileModal from "./FileModal";
import BackButton from "components/refactoring/BackButton";
import countryList from "react-select-country-list";
import { ID_TYPES } from "services/util";

const Contact = ({ label, model, t, ...props }) => (
  <Fieldset model={model} className="mb-1" component={FormGroup}>
    <Row noGutters>
      <Col xs={12} sm={3} style={{ maxWidth: 100 }}>{label}</Col>
      <Col xs={12} sm={9} className="pr-1">
        <Row noGutters>
          <Col xs="auto" className="pr-1">
            <Control.text
              className="form-control-sm"
              updateOn="blur"
              model=".PhoneCountryCode"
              placeholder={t("+(Code)")}
              style={{ width: 100 }}
            />
          </Col>
          <Col xs="auto">
            <Control.text
              updateOn="blur"
              className="form-control-sm"
              model=".PhoneNumber"
              placeholder={t("Phone Number")}
              style={{ width: 200 }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  </Fieldset>

);

const validateBuildingNumber = (val) => {
  const isValid = /^\d{1,4}$/.test(val);
  return isValid;
};

const NumbersOnlyInput = ({ model, placeholder, className, t }) => {
  return (
    <>
      <Control.text
        maxLength="4"
        placeholder={placeholder}
        model={model}
        className={`form-control ${className}`}
        validators={{
          validBuildingNumber: validateBuildingNumber,
        }}
        type="numeric"
      />
      <Errors
        model={model}
        messages={{
          validBuildingNumber: t('Please enter a valid 4-digit number.'),
        }}
        show={{ touched: true, focus: false }}
        wrapper={(props) => <div style={{ color: 'red' }}>{props.children}</div>}
      />
    </>
  );
};

const validNumber = <Trans>Please enter a valid 4-digit number</Trans>

const Address = ({ model, label, t, form, countryOptions }) => {

  {/*const filteredNums = (value) => value && /\D/.test(value);
 
  const taxAddress = form?.Addresses?.find(address => address?.AddressType?.initialValue === 'POBOX')
  const isValidNum = taxAddress?.AddressLine3.value
  const isValidNumber = taxAddress?.AddressLine4.value
  
  const errorMessage =  filteredNums(isValidNumber) && <span style={{ color: 'red' }}>{validNumber}</span>
  const errorMess = filteredNums(isValidNumber) && <span style={{ color: 'red' }}>{validNumber}</span>

  console.log(taxAddress, form?.Addresses, "form?.Addresses")
  console.log(isValidNum, isValidNumber, "valids")*/}

  return (

    <Fieldset model={model} component={FormGroup} label={label}>
      <div className="d-flex flex-column pt-2 pb-2">
        <Control.text
          updateOn="blur"
          placeholder={t("Address Person Name")}
          className="mb-2"
          model=".AttentionTo"
        />
        <Row>
          <Col>
            <Control.text maxLength="4" model=".AddressLine4" placeholder={t("Building Number")} className="mb-2" t={t} />
          </Col>
          <Col>
            <Control.text maxLength="4" model=".AddressLine3" placeholder={t("Plot Number")} className="mb-2" t={t} />
          </Col>
        </Row>
        {/*errorMess*/}
        {/*errorMessage*/}
        <Control.text updateOn="blur" model=".AddressLine1" className="mb-2" placeholder={t("Address Line")} />
        <Row>
          <Col>
            <Control.text
              updateOn="blur"
              placeholder={t("City/Town")}
              model=".City"
              className="mb-2"
            />
          </Col>
          <Col>
            <Control.text
              updateOn="blur"
              placeholder={t("State/Region")}
              model=".Region"
              className="mb-2"
            />
          </Col>
          <Col>
            <Control.text
              updateOn="blur"
              placeholder={t("Postal/ Zip Code")}
              model=".PostalCode"
              className="mb-2"
              maxLength="5"
            />
          </Col>
          <Col>
            <Control
              component={Select}
              model=".Country"
              placeholder={t("Country")}
              options={countryOptions}
              simpleValue
              style={{ backgroundColor: '#F4F7FE' }}
            />
          </Col>
        </Row>
        {/* <Control.text
        updateOn="blur"
        placeholder={t("Country")}
        model=".Country"
      /> */}
      </div>
    </Fieldset>
  )
};

const validatePaymentTerms = (v) => {
  if (!v) return true;
  if (!(v.Day || v.Type)) return true;
  return v.Day && v.Type;
};

export const ContactEdit = ({
  title,
  setState,
  form,
  item,
  onSubmit,
  accounts,
  tax_rates,
  dispatch,
  currencies,
  handleAddAnotherPerson,
  handleRemovePerson,
  errors,
  XeroErrors,
  xero,
  reload,
  t,
  fileModalOpen = false,
  history,
  ...props
}) => {
  const viewLink = () => {
    const { ContactID } = item;

    history.push(`/contacts/view/${ContactID}`)
  };

  const countryOptions = useMemo(() => countryList().getData(), [])

  const idTypes = useMemo(() => ID_TYPES, [])

  const [isPaymentTerms, setPaymentTerms] = useState(false)

  return (

    <Page title={title}>
      <BackButton />
      <br />
      <LocalForm
        initialState={item}
        onUpdate={(form) => setState({ form })}
        onChange={(item) => setState({ item })}
        onSubmit={onSubmit}
        getDispatch={(dispatch) => setState({ dispatch })}
        validators={{
          Name: { required },
          EmailAddress: { required: (v) => !v || isEmail(v) },
          "ContactPersons[].EmailAddress": { required: (v) => !v || isEmail(v) },
          "PaymentTerms.Bills": { required: validatePaymentTerms },
          "PaymentTerms.Sales": { required: validatePaymentTerms },
          "ContactPersons[]": {
            required: (v) => v.FirstName || v.LastName || v.EmailAddress,
          },
        }}
      >
        {item.ContactID && (
          <div className="d-flex justify-content-end mb-3">
            <Button
              color="primary"
              className="tw-mr-3"
              onClick={() => setState({ fileModalOpen: true })}
            >
              <span className="fa fa-file" />{" "}
              {item.Attachments.length > 0 && item.Attachments.length}
            </Button>
            <UncontrolledButtonDropdown>
              <DropdownToggle caret color="primary" className="btn-sm">
                <Trans>Contact Options</Trans>
              </DropdownToggle>
              <DropdownMenu>
                <Link
                  className="dropdown-item"
                  to={`/reports/aged_payables_by_contact/${item.ContactID}`}
                >
                  <Trans>Aged Payables Report</Trans>
                </Link>
                <Link
                  className="dropdown-item"
                  to={`/reports/aged_receivables_by_contact/${item.ContactID}`}
                >
                  <Trans>Aged Receivables Report</Trans>
                </Link>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
            <button
              type="button"
              className="btn-sm btn btn-primary"
              onClick={viewLink}>
              <Trans>View Contact</Trans>
            </button>
          </div>
        )}
        <XeroErrors />
        <FormGroup model=".Name" label="Contact Name" className="pt-2 pb-2">
          <Control.text model=".Name" updateOn="blur" />
        </FormGroup>
        <FormGroup model=".AccountNumber" label="Account Number" className="pt-2 pb-2">
          <Control.text model=".AccountNumber" updateOn="blur" />
        </FormGroup>
        <FormGroup label="Primary Person" className="pt-2 pb-2">
          <Row>
            <Col className="mb-3 mb-md-0" xs={12} md>
              <Control.text
                model=".FirstName"
                updateOn="blur"
                placeholder={t("First")}
              />
            </Col>
            <Col xs={12} md>
              <Control.text
                model=".LastName"
                updateOn="blur"
                placeholder={t("Last")}
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup label="Email" model=".EmailAddress" className="pt-2 pb-2">
          <Control.text model=".EmailAddress" updateOn="blur" />
        </FormGroup>
        <hr />
        {(item.ContactPersons || []).map((i, idx) => (
          <Fieldset model={`.ContactPersons[${idx}]`} key={idx}>
            <FormGroup>
              <div className="d-flex mb-2">
                <span>{(item.ContactPersons.length > 1) ? `Contact Person ${idx + 1}:` : 'Contact Person:'}</span>
                {(item.ContactPersons.length > 1) && (
                  <Button
                    color="link"
                    className="p-0 ml-auto"
                    onClick={() => handleRemovePerson(idx)}
                  >
                    <span className="fa fa-times text-muted" />
                  </Button>
                )}
              </div>
              <Row>
                <Col xs={12} md className="mb-3 mb-md-0">
                  <Control.text
                    updateOn="blur"
                    model=".FirstName"
                    placeholder={t("First")}
                  />
                </Col>
                <Col xs={12} md>
                  <Control.text
                    updateOn="blur"
                    model=".LastName"
                    placeholder={t("Last")}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup label="Email" model=".EmailAddress">
              <Control.text updateOn="blur" model=".EmailAddress" />
            </FormGroup>
            <FormGroup label="Include in Emails?" check>
              <Control.checkbox model=".IncludeInEmails" />
            </FormGroup>
          </Fieldset>
        ))}

        <Button className="p-0" onClick={handleAddAnotherPerson} color="link">
          <Trans>Add another person</Trans>
        </Button>
        <hr />
        <Contact className="pt-2 pb-2"
          model={track(".Phones[]", { PhoneType: "DEFAULT" })}
          label="Phone"
          t={t}
        />
        <Contact className="pt-2 pb-2"
          model={track(".Phones[]", { PhoneType: "DDI" })}
          label="Direct dial"
          t={t}
        />
        <Contact className="pt-2 pb-2"
          model={track(".Phones[]", { PhoneType: "FAX" })}
          label="Fax"
          t={t}
        />
        <Contact className="pt-2 pb-2"
          model={track(".Phones[]", { PhoneType: "MOBILE" })}
          label="Mobile"
          t={t}
        />
        <Row style={{ marginTop: "1rem" }}>
          <Col>
            <FormGroup label="Website" model=".Website">
              <Control.text updateOn="blur" model=".Website" />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup label="Primary Location" model=".PLocation">
              <Control.text updateOn="blur" model=".PLocation" />
            </FormGroup>
          </Col>
        </Row>
        <hr />
        <Address className="pt-2 pb-2"
          form={form}
          model={track(".Addresses[]", { AddressType: "POBOX" })}
          label="Tax/Billing Address"
          countryOptions={countryOptions}
          t={t}
        />
        <Address className="pt-2 pb-2"
          form={form}
          model={track(".Addresses[]", { AddressType: "STREET" })}
          label="Delivery Address"
          countryOptions={countryOptions}
          t={t}
        />

        <hr />
        <h4 className="card-title pt-2 pb-2">
          <Trans>Financial Details</Trans>
        </h4>
        <FormGroup label="Bank Account Number">
          <Control.text
            updateOn="blur"
            model=".BankAccountDetails"
            placeholder={t("Linked Account Number")}
            className="mb-2 pt-2 pb-2"
          />
          <Row>
            <Col>
              <FormGroup label="Sales Settings" model=".SalesDefaultAccountCode" className="pt-2 pb-2">
                <AccountSelect
                  prependCode
                  model=".SalesDefaultAccountCode"
                  accounts={accounts}
                  simpleValue
                  placeholder={t("Default account")} style={{ backgroundColor: '#F4F7FE' }}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup
                label="Purchase Settings"
                model=".PurchasesDefaultAccountCode" className="pt-2 pb-2"
              >
                <AccountSelect
                  prependCode
                  model=".PurchasesDefaultAccountCode"
                  accounts={accounts}
                  simpleValue
                  placeholder={t("Default account")} style={{ backgroundColor: '#F4F7FE' }}
                />
              </FormGroup>
            </Col>
          </Row>
        </FormGroup>

        <FormGroup label="VAT">
          <Control.text
            updateOn="blur"
            model=".TaxNumber"
            placeholder={t("Tax Number")}
            className="mb-2 pt-2 pb-2"
          />
          <Row>
            <Col>
              <Control
                component={Select}
                model=".AccountsReceivableTaxType"
                labelKey="Name"
                valueKey="TaxType"
                placeholder={t("Default sales VAT")}
                options={tax_rates}
                simpleValue
                className="mb-2" style={{ backgroundColor: '#F4F7FE' }}
              />
            </Col>
            <Col>
              <Control
                component={Select}
                model=".AccountsPayableTaxType"
                labelKey="Name"
                valueKey="TaxType"
                placeholder={t("Default purchases VAT")}
                options={tax_rates}
                simpleValue style={{ backgroundColor: '#F4F7FE' }}
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup label="Registration Number" model=".CompanyNumber" className="pt-2 pb-2">
          <Control.text
            updateOn="blur"
            model=".CompanyNumber"
            placeholder={t("Registration Number")}
            className="mb-2 pt-2 pb-2"
          />
        </FormGroup>
        <Row>
          <Col>
            <FormGroup label="ID Type" model=".id_type" className="pt-2 pb-2">
              <Control
                component={Select}
                model=".id_type"
                labelKey="label"
                valueKey="id"
                placeholder={t("Select...")}
                options={idTypes}
                simpleValue
                className="mb-2" style={{ backgroundColor: '#F4F7FE' }}
              />
            </FormGroup>
          </Col>
          {item.id_type === 'OTH' && <Col>
            <FormGroup label="ID Name" model=".id_name" className="pt-2 pb-2">
              <Control.text
                updateOn="blur"
                model=".id_name"
                placeholder={t("ID Name")}
                className="mb-2 pt-2 pb-2"
              />
            </FormGroup>
          </Col>}
          <Col>
            <FormGroup label="ID Number" model=".id_number" className="pt-2 pb-2">
              <Control.text
                updateOn="blur"
                model=".id_number"
                placeholder={t("ID Number")}
                className="form-control"
              />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup label="Currency" model=".DefaultCurrency" className="pt-2 pb-2">
          <Control
            component={Select}
            placeholder={t("Default currency")}
            model=".DefaultCurrency"
            labelKey="Description"
            valueKey="Code"
            options={currencies}
            simpleValue style={{ backgroundColor: '#F4F7FE' }}
          />
        </FormGroup>
        {!isPaymentTerms &&
          <div className="d-flex my-2" >
            <div style={{ cursor: "pointer", fontSize: "1.1em" }} onClick={() => setPaymentTerms(true)} className="text-success align-items-center"><Trans>Payment Terms</Trans> <i className="fa fa-sort-down" /></div>
          </div>
        }
        {isPaymentTerms &&
          <div className="mt-2">
            <Fieldset model=".PaymentTerms.Bills" className="pt-2 pb-2">
              <FormGroup label="Bills Due Date" model="." addControlClass={false}>
                <Row>
                  <Col>
                    <Control.text
                      updateOn="blur"
                      model=".Day"
                      placeholder={t("Due")}
                      className="form-control"
                    />
                  </Col>
                  <Col>
                    <Control.text
                      model=".Type"
                      component={Select}
                      clearable={false}
                      options={paymentTerms}
                      simpleValue style={{ backgroundColor: '#F4F7FE' }}
                      placeholder={t('Select...')}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </Fieldset>
            <Fieldset model=".PaymentTerms.Sales">
              <FormGroup label="Invoice Due Date" model="." addControlClass={false}>
                <Row>
                  <Col>
                    <Control.text
                      updateOn="blur"
                      model=".Day"
                      placeholder={t("Due")}
                      className="form-control"
                    />
                  </Col>
                  <Col>
                    <Control.text
                      model=".Type"
                      component={Select}
                      clearable={false}
                      options={paymentTerms}
                      simpleValue style={{ backgroundColor: '#F4F7FE' }}
                      placeholder={t('Select...')}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </Fieldset>
          </div>
        }
        <div className="d-flex justify-content-end">
          <SaveButton form={form} className="my-3 mx-0" />
        </div>
      </LocalForm>
      {fileModalOpen && (
        <FileModal
          item={item}
          setItem={(item) => setState({ item: item })}
          xero={xero}
          close={() => setState({ fileModalOpen: false })}
        />
      )}
    </Page>
  )
};

const currencySelector = createSelector(
  (i) => i,
  (i) =>
    i.map((j) => ({
      ...j,
      Description: `${j.Code} ${j.Description}`,
    }))
);

export const enhance = compose(
  withReload(),
  withStateHandlers(
    {},
    {
      setState: () => (state) => ({ ...state }),
    }
  ),
  withPropsOnChange([], ({ xero, match, setState, t }) => {
    const { id } = match.params;

    Promise.props({
      item:
        id === "new"
          ? {
            Phones: ["DEFAULT", "DDI", "FAX", "MOBILE"].map((PhoneType) => ({
              PhoneType,
            })),
            Addresses: ["POBOX", "STREET"].map((AddressType) => ({
              AddressType,
            })),
            ContactPersons: [],
            PaymentTerms: {},
            BatchPayments: {},
          }
          : xero.get(`contacts/${id}`).get("data"),
      accounts: xero.get("accounts").get("data"),
      tax_rates: xero.get("taxrates").get("data"),
      currencies: xero.get("currencies").get("data").then(currencySelector),
      title: id === "new" ? t("Add Contact") : t("Edit Contact"),
      ready: true,
    }).then(setState);
  }),
  branch(
    (props) => !props.ready,
    () => () => null
  ),
  withXeroErrors(),
  withHandlers({
    handleAddAnotherPerson:
      ({ dispatch }) =>
        () => {
          dispatch(actions.push("local.ContactPersons", {}));
        },
    handleCopyPostal:
      ({ dispatch }) =>
        () => {
          dispatch(actions.change("local."));
        },
    handleRemovePerson:
      ({ dispatch }) =>
        (idx) => {
          dispatch(actions.remove("local.ContactPersons", idx));
        },
    onSubmit:
      ({
        xero,
        history,
        match,
        dispatch,
        setState,
        t,
        reload,
        setXeroErrors,
      }) =>
        (tmpItem) => {
          let item = tmpItem;
          if (tmpItem.PaymentTerms) {
            item = produce(item, (draft) => {
              const { PaymentTerms } = draft;
              PaymentTerms.Bills = PaymentTerms.Bills?.Day
                ? PaymentTerms.Bills
                : undefined;
              PaymentTerms.Sales = PaymentTerms.Sales?.Day
                ? PaymentTerms.Sales
                : undefined;
            });
          }

          if (tmpItem.Addresses) {
            item = produce(item, (draft) => {
              const { Addresses } = draft;
              draft.Addresses = Addresses.map((address) => {
                if (address.Country === null) {
                  return { ...address, Country: "" };
                }
                return address;
              });
            });
          }


          const { SalesTrackingCategories, PurchasesTrackingCategories, ...remaining } = item
          item = {...remaining, BankAccountDetails: item.BankAccountDetails || undefined}

          setXeroErrors(null);

          const p = item.ContactID
            ? xero.put(`contacts/${item.ContactID}`, item)
            : xero.post("contacts", item);

          return p
            .get("data")
            .tap(({ ContactID }) => {
              NotificationManager.success(t("Saved successfully"));
              history.replace(`/contacts/view/${ContactID}`);
              reload();
            })
            .catch((err) => {
              dispatch(actions.setPending("local", false));
              setXeroErrors(err);
            });
        },
  })
);

export default enhance(ContactEdit);
